import { SERVER_TIME_OFFSET } from '../../actions/configuration';

const serverTimeOffset = (state = 0, action = undefined) => {
    if (action.type === SERVER_TIME_OFFSET) {
        return action.payload;
    }
    return state;
};

export default serverTimeOffset;
